import React from 'react'

import { Container } from './styles'

// Using class instead of hooks so that duplicating on Sundae should be just copy and paste.
export default class CookieConsent extends React.Component {
  constructor() {
    super()
    this.state = {
      active: false,
      status: '',
    }
  }

  componentDidMount() {
    setTimeout(() => this.setActive(true), 500)
  }

  getCookieName = () => 'cookieconsent_status'
  getCookieValue = () => 'dismiss'

  checkForConsentCookie = () =>
    document.cookie
      .split(';')
      .filter((item) => item.trim().startsWith(`${this.getCookieName()}=`))
      .length > 0

  setConsentCookie = () => {
    const date = new Date()
    date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000)
    document.cookie = `${this.getCookieName()}=${this.getCookieValue()}; expires=${date.toLocaleString()}; path=/`
    this.setState({ status: 'set' })
  }

  setActive = (nextActive) => this.setState({ active: nextActive })

  handleClick = () => {
    this.setActive(false)
    setTimeout(this.setConsentCookie, 500)
  }

  render() {
    const consent = this.checkForConsentCookie()
    const { active, status } = this.state

    if (consent || status === 'set') {
      return null
    }

    return (
      <Container
        role="dialog"
        aria-live="polite"
        aria-label="cookieconsent"
        aria-describedby="cookieconsent:desc"
        active={active}
      >
        <p id="cookieconsent:desc">
          SMARTY uses delicious cookies.
          <a
            aria-label="learn more about cookies"
            role="button"
            tabIndex="0"
            href="/cookies"
            rel="noopener noreferrer nofollow"
            target="_blank"
          >
            Read about them here.
          </a>
        </p>
        <button aria-label="dismiss cookie message" onClick={this.handleClick}>
          Got it
        </button>
      </Container>
    )
  }
}
